import { Vacancy } from "../..";
import { MovementLocation } from "../../movement/movement-location";
import { MovementPlanDestinyCreateDTO } from "./movement-plan-destiny-createDTO";

export class LocationFinishDTO {
    movementLocation: MovementLocation;
    vacancy?: Vacancy;
    nextsMovements?: MovementPlanDestinyCreateDTO[];
}